/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_PAYOUT_STATUS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.payoutDetail.update.payoutStatus',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_PAYOUT_STATUS' },
      },
    },
    UPDATE_PAYOUT_STATUS: {
      invoke: {
        id: 'updatePayout',
        src: 'updatePayout',
        onDone: {
          target: 'UPDATE_PAYOUT_STATUS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_PAYOUT_STATUS_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_PAYOUT_STATUS_SUCCESS: {
      on: {
        START: { target: 'UPDATE_PAYOUT_STATUS' },
      },
    },
    UPDATE_PAYOUT_STATUS_FAILED: {
      on: {
        START: { target: 'UPDATE_PAYOUT_STATUS' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
